import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { ApiDropPart } from "@/generated/models/ApiDropPart";
import WaveDropPartTitle from "./WaveDropPartTitle";
import WaveDropPartContent from "./WaveDropPartContent";
import { ImageScale } from "@/helpers/image.helpers";
interface WaveDropPartDropProps {
  drop: ApiDrop;
  activePart: ApiDropPart;
  havePreviousPart: boolean;
  haveNextPart: boolean;
  isStorm: boolean;
  activePartIndex: number;
  setActivePartIndex: (index: number) => void;
  onQuoteClick: (drop: ApiDrop) => void;
  isEditing?: boolean | undefined;
  isSaving?: boolean | undefined;
  readonly onSave?: ((newContent: string) => void) | undefined;
  readonly onCancel?: (() => void) | undefined;
  isCompetitionDrop?: boolean | undefined;
  mediaImageScale?: ImageScale | undefined;
}
const WaveDropPartDrop: React.FC<WaveDropPartDropProps> = t0 => {
  const $ = _c(20);
  const {
    drop,
    activePart,
    havePreviousPart,
    haveNextPart,
    isStorm,
    activePartIndex,
    setActivePartIndex,
    onQuoteClick,
    isEditing: t1,
    isSaving: t2,
    onSave,
    onCancel,
    isCompetitionDrop: t3,
    mediaImageScale: t4
  } = t0;
  const isEditing = t1 === undefined ? false : t1;
  const isSaving = t2 === undefined ? false : t2;
  const isCompetitionDrop = t3 === undefined ? false : t3;
  const mediaImageScale = t4 === undefined ? ImageScale.AUTOx450 : t4;
  let t5;
  if ($[0] !== drop.title) {
    t5 = <WaveDropPartTitle title={drop.title} />;
    $[0] = drop.title;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== activePart || $[3] !== activePartIndex || $[4] !== drop || $[5] !== haveNextPart || $[6] !== havePreviousPart || $[7] !== isCompetitionDrop || $[8] !== isEditing || $[9] !== isSaving || $[10] !== isStorm || $[11] !== mediaImageScale || $[12] !== onCancel || $[13] !== onQuoteClick || $[14] !== onSave || $[15] !== setActivePartIndex) {
    t6 = <WaveDropPartContent mentionedUsers={drop.mentioned_users} referencedNfts={drop.referenced_nfts} wave={drop.wave} activePart={activePart} havePreviousPart={havePreviousPart} haveNextPart={haveNextPart} isStorm={isStorm} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onQuoteClick={onQuoteClick} isEditing={isEditing} isSaving={isSaving} onSave={onSave} onCancel={onCancel} drop={drop} isCompetitionDrop={isCompetitionDrop} mediaImageScale={mediaImageScale} />;
    $[2] = activePart;
    $[3] = activePartIndex;
    $[4] = drop;
    $[5] = haveNextPart;
    $[6] = havePreviousPart;
    $[7] = isCompetitionDrop;
    $[8] = isEditing;
    $[9] = isSaving;
    $[10] = isStorm;
    $[11] = mediaImageScale;
    $[12] = onCancel;
    $[13] = onQuoteClick;
    $[14] = onSave;
    $[15] = setActivePartIndex;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = <div className="tw-flex tw-gap-x-3 tw-h-full tw-relative"><div className="tw-flex tw-flex-col tw-w-full tw-h-full tw-self-center sm:tw-self-start"><div>{t5}{t6}</div></div></div>;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
export default WaveDropPartDrop;